import { Section } from '@design-system/section';
import classNames from 'classnames';
import React, { forwardRef } from 'react';

import BodyRender from '~/components/BodyRender';

import { SplitterProps } from './models';
import { transformGridToColumns } from './utils';

const Splitter = forwardRef<HTMLDivElement, SplitterProps>(
  ({ currentPageUid, uid, grid, externalData }, ref) => {
    const columns = transformGridToColumns(grid);

    return (
      <Section
        ref={ref}
        className="splitter"
        mode="transparent"
        removeAllSpacing
        data-component-uid={uid}
      >
        <div className="splitter__grid">
          {Object.values(columns).map(
            ({ column, size, stretchVariant, isSticky }, index) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className={classNames('splitter__grid-container', {
                  [`splitter__grid-container-${size}`]: size,
                  [`splitter__grid-container--${stretchVariant}`]:
                    stretchVariant,
                })}
              >
                <div
                  className={classNames('splitter__grid-item', {
                    [`splitter__grid-item-${size}`]: size,
                    [`splitter__grid-item--${stretchVariant}`]: stretchVariant,
                    [`splitter__grid-item--sticky`]: isSticky,
                  })}
                >
                  <BodyRender
                    items={column}
                    externalData={externalData}
                    currentPageUid={currentPageUid}
                  />
                </div>
              </div>
            )
          )}
        </div>
      </Section>
    );
  }
);

export default Splitter;
